export interface Environment {
  production: boolean;
  apiUxUrl: string;
  authConfig: AuthConfig;
  qlikConfig: QlikConfig;
  matomo: MatomoConfig;
  zendesk: ZendeskConfig;
  synapse: SynapseConfig;
  lienRedirectionB2S: string;
  VERSION: string;
}

export interface MatomoConfig {
  url: string;
  siteId: number;
}

export interface AuthConfig {
  loginUrl: string;
  logoutUrl: string;
  tokenUrl: string;
  clientId: string;
  frontExpirationMinutes: number;
}

export enum QlikConfig {
  Default,
  Integration,
  Recette,
  Production
}

export interface ZendeskConfig {
  url: string;
}

export interface SynapseConfig {
  apiKey: string;
  clientName: string;
  categories: string[];
}
